export const rugbyBundesligaTrainerSymposium2026Referenten = {
  "id": "rugby-bundesliga-trainersymposium-2026-referenten",
  "title": "Hochkarätige internationale Expertise: Zwei weitere Referenten für das Online Rugby-Bundesligatrainer*innen-Symposium 2026 bestätigt",
  "slug": "online-rugby-bundesliga-trainersymposium-2026-weitere-referenten",
  "publishedAt": "2026-02-06T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Trainerbildung",
    "Symposium",
    "Coach Education",
    "Analyse",
    "Internationales Rugby"
  ],
  "excerpt": "Das 1. Online Rugby-Bundesligatrainer*innen-Symposium 2026 erhält mit Johann Zeier und Francisco Deformes weitere hochkarätige Referenten und gewinnt damit zusätzlich an internationaler und fachlicher Tiefe.",
  "img": "/images/rugby-bundesliga-trainersymposium-2026-referenten.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Das 1. Online Rugby-Bundesligatrainer*innen-Symposium 2026 gewinnt weiter an fachlicher Tiefe und internationalem Profil. Mit Johann Zeier und Francisco Deformes konnten zwei weitere ausgewiesene Experten als Referenten für die Veranstaltung am 1. März 2026 gewonnen werden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Johann Zeier: Analysearbeit im modernen Leistungsrugby"
    },
    {
      "type": "paragraph",
      "content": "Johann Zeier ist Spielanalyst im deutschen 7er-Programm und bringt umfassende Expertise im Bereich der Video- und Spielanalyse mit. In seinem Beitrag wird er praxisnah aufzeigen, wie moderne Analyseinstrumente effektiv im Leistungsrugby eingesetzt werden können und welchen Mehrwert strukturierte Videoanalyse für Trainingssteuerung und Spielvorbereitung bietet."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Francisco Deformes: Internationale Impulse aus Neuseeland"
    },
    {
      "type": "paragraph",
      "content": "Mit Francisco Deformes erhält das Symposium zudem einen spannenden internationalen Impuls aus einem der führenden Rugbyländer der Welt. Der gebürtige Chilene arbeitet als Rugbytrainer in Neuseeland und ist dort für Hawke’s Bay sowie das NPC-Team Manawatū (Mampies) tätig."
    },
    {
      "type": "paragraph",
      "content": "In seiner Rolle als Development Coach und Scrum-Spezialist ist Deformes maßgeblich an der Ausbildung von Spielerinnen und Trainern beteiligt. Er wird Einblicke in seine tägliche Arbeit im neuseeländischen Rugbysystem geben und aufzeigen, wie Entwicklungsprozesse, Detailarbeit im Gedränge und langfristige Ausbildungsstrukturen dort gestaltet werden."
    },
    {
      "type": "paragraph",
      "content": "Mit der Verpflichtung dieser beiden Referenten erweitert das Symposium sein inhaltliches Spektrum deutlich und unterstreicht den Anspruch, hochwertige, praxisnahe und international inspirierte Trainer*innenfortbildung anzubieten."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Anmeldung und Teilnahmegebühr"
    },
    {
      "type": "paragraph",
      "content": "Die Anmeldung erfolgt verbindlich per E-Mail an:"
    },
    {
      "type": "paragraph",
      "content": "coachingbl@rugbydeutschland.org"
    },
    {
      "type": "paragraph",
      "content": "Anmeldeschluss: 23. Februar 2026"
    },
    {
      "type": "paragraph",
      "content": "Die Teilnahmegebühr beträgt 25,00 € und ist nach Anmeldung an Rugby Deutschland e. V. zu überweisen."
    },
    {
      "type": "heading",
      "level": 3,
      "content": "Bankverbindung"
    },
    {
      "type": "list",
      "items": [
        "Rugby Deutschland e. V.",
        "IBAN: DE10672700030140190000",
        "BIC: DEUTEDESM672",
        "Bank: Deutsche Bank",
        "Verwendungszweck: Bundesligatrainer-Symposium 1.3.2026"
      ]
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Organisation"
    },
    {
      "type": "paragraph",
      "content": "Das Symposium wird von Björn Frommann organisiert. Er ist A-Lizenztrainer, Referent und seit vielen Jahren im Trainer*innenumfeld aktiv."
    },
    {
      "type": "paragraph",
      "content": "Beruflich ist er als Lehrer und Schulprozessbegleiter tätig. Aktuell unterstützt er den Rugby-Bundesligaausschuss als Referent für Trainer*innenbildung und Wissenstransfer."
    }

  ]
};
